// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3fCMo","container":"styles_container__1U54g","title":"styles_title__le2Vf","wrapper":"styles_wrapper__1Tay6","answer":"styles_answer__hzZuk"};